<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="$modal.closeModal"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mContentEditorModalAllowedUrl.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section-height-auto">
        <div class="url-category-header">
          <i class="fab fa-youtube"></i>
          <span>{{ $t(`mContentEditorModalAllowedUrl.youtube.title`) }}</span>
        </div>
        <div class="url-category-list font-size-small">
          <ul>
            <li>{{ $t(`mContentEditorModalAllowedUrl.youtube.list.url1`) }}</li>
            <li>{{ $t(`mContentEditorModalAllowedUrl.youtube.list.url2`) }}</li>
            <li>{{ $t(`mContentEditorModalAllowedUrl.youtube.list.url3`) }}</li>
          </ul>
          <p><i>{{ $t(`mContentEditorModalAllowedUrl.youtube.description`) }}</i></p>
        </div>
        <div class="url-category-header">
          <i class="fab fa-vimeo"></i>
          <span>{{ $t(`mContentEditorModalAllowedUrl.vimeo.title`) }}</span>
        </div>
        <div class="url-category-list font-size-small">
          <ul>
            <li>{{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url1`) }}</li>
            <li>{{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url2`) }}</li>
            <li>{{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url3`) }}</li>
            <li>{{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url4`) }}</li>
            <li>{{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url5`) }}</li>
            <li>{{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url6`) }}</li>
            <li>{{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url7`) }}</li>
            <li>{{ $t(`mContentEditorModalAllowedUrl.vimeo.list.url8`) }}</li>
          </ul>
          <p><i>{{ $t(`mContentEditorModalAllowedUrl.vimeo.description`) }}</i></p>
        </div>
        <div class="url-category-header">
          <i class="fab fa-amazon"></i>
          <span>{{ $t(`mContentEditorModalAllowedUrl.amazon.title`) }}</span>
        </div>
        <div class="url-category-list font-size-small">
          <ul>
            <li>{{ $t(`mContentEditorModalAllowedUrl.amazon.list.url1`) }}</li>
          </ul>
          <p><i>{{ $t(`mContentEditorModalAllowedUrl.amazon.description`) }}</i></p>
        </div>
        <div class="url-category-header">
          <i class="fas fa-rabbit-fast"></i>
          <span>{{ $t(`mContentEditorModalAllowedUrl.bunny.title`) }}</span>
        </div>
        <div class="url-category-list font-size-small">
          <ul>
            <li>{{ $t(`mContentEditorModalAllowedUrl.bunny.list.url1`) }}</li>
            <li>{{ $t(`mContentEditorModalAllowedUrl.bunny.list.url2`) }}</li>
            <li>{{ $t(`mContentEditorModalAllowedUrl.bunny.list.url3`) }}</li>
          </ul>
          <p><i>{{ $t(`mContentEditorModalAllowedUrl.bunny.description`) }}</i></p>
        </div>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>
<script>
export default {
  name: 'MoleculeContentEditorModalAllowedUrl',

  data () {
    return {
      buttonPrimary: {
        action: 'ENTENDIDO',
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      }
    }
  }
}
</script>
